import { render, staticRenderFns } from "./VendorSignupStripe.vue?vue&type=template&id=09dc010b&scoped=true"
import script from "./VendorSignupStripe.vue?vue&type=script&lang=js"
export * from "./VendorSignupStripe.vue?vue&type=script&lang=js"
import style0 from "./VendorSignupStripe.vue?vue&type=style&index=0&id=09dc010b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dc010b",
  null
  
)

export default component.exports